import { useEffect } from 'react';
import { useParams } from 'react-router';
import ArticuloForm from '../../components/articulos/ArticuloForm';
import { useArticulosStore, type ActualizarArticulo } from '../../stores/articulos/articulos.store';

const EditarArticulo = () => {
  const id = useParams<{ id: string }>().id ?? '';
  const {
    current: articulo,
    actualizar,
    cargarPorId,
    desactivar,
    activar
  } = useArticulosStore((state) => state);

  useEffect(() => {
    if (!id) return;

    cargarPorId(id);
  }, [id]);

  const handleSave = async (values: ActualizarArticulo) => {
    return actualizar(id, values);
  };

  const handleDelete = async () => {
    await desactivar(id);
  };

  const handleActivate = async () => {
    await activar(id);
  };

  return (
    <ArticuloForm
      articulo={articulo}
      onSave={handleSave}
      onDelete={handleDelete}
      onActivate={handleActivate}
    />
  );
};

export default EditarArticulo;
